import React, { useState } from "react";
import { Link } from "react-router-dom";
import { S3URL } from "../../../data/globalConstants";
import NavMenuItem from "./NavMenuItem";

export default function NavMenuMobile({ navData }) {
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const handleAccordionToggle = (slug) => {
    setOpenSubmenu((prev) => (prev === slug ? null : slug));
  };

  return (
    <nav className="nav-mobile-accordion" aria-label="Mobile genre navigation">
      <ul className="nav-mobile-accordion-list">
        {navData &&
          navData.map((item) => {
            const isOpen = openSubmenu === item.slug;

            return (
              <li
                key={item.slug}
                className={
                  "nav-mobile-accordion-item " + (isOpen ? "is-open" : "")
                }
              >
                <button
                  type="button"
                  className="nav-mobile-accordion-trigger"
                  onClick={() => handleAccordionToggle(item.slug)}
                  aria-expanded={isOpen ? "true" : "false"}
                  aria-controls={`mobile-accordion-panel-${item.slug}`}
                >
                  <span className="nav-mobile-accordion-title">
                    {item.title}
                  </span>

                  <img
                    src="/img/ico/chevron-down.png"
                    alt=""
                    aria-hidden="true"
                    className="nav-mobile-accordion-icon"
                  />
                </button>

                <div
                  id={`mobile-accordion-panel-${item.slug}`}
                  className="nav-mobile-accordion-panel"
                >
                  <div className="nav-mobile-accordion-content">
                    <div className="nav-mobile-accordion-shows">
                      {item.shows &&
                        item.shows.map((submenuItem) => (
                          <NavMenuItem
                            key={submenuItem.slug}
                            parent={item}
                            submenuItem={submenuItem}
                            isMobile={true}
                          />
                        ))}
                    </div>
                    <div className="nav-mobile-accordion-seeall">
                      <Link
                        to={`/${item.slug}`}
                        aria-label={`See all ${item.title}`}
                      >
                        {`See all ${item.title}`}
                      </Link>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
      </ul>
    </nav>
  );
}
